'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _PlanScorecardQuickResults = require('./PlanScorecardQuickResults.css');

var _PlanScorecardQuickResults2 = _interopRequireDefault(_PlanScorecardQuickResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlanScorecardQuickResults = (_dec = (0, _reactCssModules2.default)(_PlanScorecardQuickResults2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlanScorecardQuickResults, _Component);

  function PlanScorecardQuickResults(props) {
    (0, _classCallCheck3.default)(this, PlanScorecardQuickResults);
    return (0, _possibleConstructorReturn3.default)(this, (PlanScorecardQuickResults.__proto__ || (0, _getPrototypeOf2.default)(PlanScorecardQuickResults)).call(this, props));
  }

  (0, _createClass3.default)(PlanScorecardQuickResults, [{
    key: 'render',
    value: function render() {
      if (!this.props.planData) {
        return null;
      }
      var planData = this.props.planData;


      var hasPrimaryPlanLogo = false;
      var primaryPlanLogo = null;
      try {
        primaryPlanLogo = require('../../../static/images/plans/' + planData.path + '.png');
        hasPrimaryPlanLogo = true;
      } catch (e) {
        console.log('');
      }

      var totCount = planData.plan_option_count;
      var esgCount = planData.plan_option_sri_count;
      var esgPerc = _format2.default.perc(planData.allocations.sri / planData.plan_assets);
      var hasEsg = esgCount > 0;

      var climateRiskInvestment = _format2.default.money(planData.screen_results.fff[0] + planData.screen_results.fff[1] + planData.screen_results.dff[0] + planData.screen_results.dff[1], true, 'USD', true, 0);
      //
      return _react2.default.createElement(
        'div',
        { styleName: 'psqr-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'psqr-flex' },
          _react2.default.createElement(
            'div',
            { styleName: 'psqr-cell cell-name-logo' },
            hasPrimaryPlanLogo ? _react2.default.createElement('img', {
              styleName: 'name-logo',
              src: primaryPlanLogo,
              alt: planData.short_name
            }) : _react2.default.createElement(
              'div',
              { styleName: 'psqr-label' },
              planData.short_name
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'psqr-cell' },
            this.props.showLabels ? _react2.default.createElement(
              'div',
              { styleName: 'psqr-label' },
              'Sustainable default investment?'
            ) : null,
            _react2.default.createElement(
              'div',
              { styleName: 'psqr-no-value' },
              'No'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'psqr-cell' },
            this.props.showLabels ? _react2.default.createElement(
              'div',
              { styleName: 'psqr-label' },
              'Sustainable investment options?'
            ) : null,
            hasEsg ? _react2.default.createElement(
              'div',
              { styleName: 'psqr-yes-value' },
              esgCount,
              ' / ',
              totCount,
              ' ',
              _react2.default.createElement(
                'span',
                { styleName: 'psqr-yes-value-small' },
                'options'
              ),
              _react2.default.createElement('br', null),
              esgPerc,
              ' ',
              _react2.default.createElement(
                'span',
                { styleName: 'psqr-yes-value-small' },
                'invested'
              )
            ) : _react2.default.createElement(
              'div',
              { styleName: 'psqr-no-value' },
              'No'
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'psqr-cell' },
            this.props.showLabels ? _react2.default.createElement(
              'div',
              { styleName: 'psqr-label' },
              'Climate-risk investments $USD'
            ) : null,
            _react2.default.createElement(
              'div',
              { styleName: 'psqr-num-value' },
              climateRiskInvestment
            )
          )
        )
      );
    }
  }]);
  return PlanScorecardQuickResults;
}(_react.Component), _class2.propTypes = {
  planData: _react.PropTypes.object,
  showLabels: _react.PropTypes.bool
}, _temp)) || _class);
exports.default = PlanScorecardQuickResults;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardQuickResults/PlanScorecardQuickResults.js
// module id = 1423
// module chunks = 0